/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramCategoryControllerGetTreeQueryResponse,
  TelegramCategoryControllerGetTreeQueryParams,
} from '../types/TelegramCategoryControllerGetTree.ts';

function getTelegramCategoryGetTreeUrl() {
  const res = { method: 'GET', url: `/api/telegram/category/tree` as const };
  return res;
}

/**
 * {@link /api/telegram/category/tree}
 */
export async function telegramCategoryGetTree(
  params?: TelegramCategoryControllerGetTreeQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramCategoryControllerGetTreeQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramCategoryGetTreeUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
